import React from 'react'
import ForgotForm from './ForgotForm'
import { ToastContainer, ToastMessage } from 'react-toastr'
import * as request from 'superagent'
import NoCache from 'superagent-no-cache'
import { hashHistory } from 'react-router'

const ToastMessageFactory = React.createFactory(ToastMessage.animation)

export default class ForgotPassword extends React.Component {
  recovery (email) {
    if (email === '') {
      this.refs.container.error('Ingrese su email', 'Error', {
        closeButton: true
      })
    } else {
      request
        .get('api/v1/user/forgot/' + email)
        .use(NoCache)
        .end((err, res) => {
          if (res.statusCode === 200) {
            this.refs.container.success('Enviamos a su correo las instrucciones para recuperar su contraseña', 'Correo enviado satisfactoriamente', {
              closeButton: true
            })
            setTimeout(() => { hashHistory.push('/') }, 2000)
          } else {
            if (err) {
              this.refs.container.error('El email ingresado no existe o es inválido', '', {
                closeButton: true
              })
            }
          }
        })
    }
  }

  render () {
    document.title = 'Recuperar Contraseña - CORE 3.0'
    return (
      <div className='form-page-container'>
        <ToastContainer toastMessageFactory={ToastMessageFactory} ref='container' className='toast-top-right' />
        <h2>Recuperar contraseña</h2>
        <div className='form-field-container'>
          <div className='description'>Ingresa tu correo y te enviaremos las instrucciones para recuperar tu contraseña</div>
        </div>
        <ForgotForm recovery={this.recovery.bind(this)} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Account/Forgot/ForgotComponent.js